import axios from "axios";
import { getAxiosErrorMessage } from "./getAxiosErrorMessage";

export interface PaginationResponse {
  count: number;
  next: string | null;
  previous: string | null;
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (axios.isAxiosError(error)) {
      error.message = getAxiosErrorMessage(error);
    }

    console.error("API Error:", error);

    return Promise.reject(error);
  },
);

export default axiosInstance;
